// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1___3674d1c005b2fc83817","cls2":"BulkFollowListModal-cls2__d915ff4e44983ee40800 BulkFollowListModal-cls1___3674d1c005b2fc83817"};